import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { SelectComponent } from '../controls/select.component';
import { BaseFieldComponent } from './base-field.component';
import { FieldContainerComponent } from './field-container.component';

@Component({
  selector: 'app-select-field',
  imports: [CommonModule, FieldContainerComponent, SelectComponent],
  template: `
    <app-field-container
      [label]="label"
      [labelCase]="labelCase"
      [labelClasses]="labelClasses"
      [valueClasses]="valueClasses"
      [control]="control"
    >
      <ng-template #value>
        <app-select
          [options]="options"
          [optionLabel]="optionLabel"
          [optionValue]="optionValue"
          [optionDisabled]="optionDisabled"
          [control]="control"
          [helpText]="helpText"
          [label]="controlLabel"
          [screenReaderLabel]="ariaLabel || controlLabel || label"
          [placeholder]="placeholder"
          [virtualScroll]="virtualScroll"
          [showClear]="showClear"
          [filter]="filter"
          [multipleFilter]="multipleFilter"
          [chip]="chip"
          [maxSelectedLabels]="maxSelectedLabels"
          [multiple]="multiple"
          [group]="group"
          [showHeader]="showHeader"
          [selectAllLabel]="selectAllLabel"
          [selectedItemsLabel]="selectedItemsLabel"
          [showHelpText]="showHelpText"
          [disabled]="disabled"
          [loading]="loading"
          [showToggleAll]="showToggleAll"
          [lockedOptions]="lockedOptions"
          [optionTemplate]="optionTemplate"
          [useLabelFor]="useLabelFor ?? multiple"
        />
      </ng-template>
    </app-field-container>
  `,
  styles: ``,
})
export class SelectFieldComponent extends BaseFieldComponent {
  /** Accessible name when it should differ from the visible field label. */
  @Input()
  ariaLabel: string;

  /** Passed to `SelectComponent`; omit to follow the same rule as inner `multiple`. */
  @Input()
  useLabelFor?: boolean;

  @Input()
  options: any[];

  @Input()
  optionLabel = 'description';

  @Input()
  optionValue = 'value';

  @Input()
  optionDisabled: string;

  @Input()
  virtualScroll = true;

  @Input()
  showClear = true;

  @Input()
  filter = true;

  @Input()
  multipleFilter = true;

  @Input()
  chip = true;

  @Input()
  multiple = false;

  @Input()
  group = false;

  @Input()
  showHeader = true;

  @Input()
  selectAllLabel = 'Select all';

  @Input()
  selectedItemsLabel: string;

  @Input()
  maxSelectedLabels = 10;

  @Input()
  disabled = false;

  @Input()
  loading = false;

  @Input()
  showToggleAll = true;

  @Input()
  lockedOptions: any[] = [];

  @Input()
  optionTemplate: TemplateRef<any>;
}
